const underConstructionDictIT = {
  comingSoon: 'Prossimamente',
  photoBy: 'Fotografato per',
}

export default underConstructionDictIT;